module.exports = __webpack_public_path__ + "img/PROGRAM_APPROVED.f0fe7356.svg";